import React from 'react';
import { PencilIcon } from './pencil';
import { TrashIcon } from './trash';
import { TruckIcon } from './truck';


export const iconMap: Record<string, React.FC<{ className?: string }>> = {
    pencil: PencilIcon,
    trash: TrashIcon,
    truck: TruckIcon
};

export const DynamicIcon: React.FC<{
  name: string;
  className?: string;
}> = ({ name, className = '' }) => {
  const IconComponent = iconMap[name.toLowerCase()];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in iconMap`);
    return null;
  }

  return <IconComponent className={className} />;
};

export {
 PencilIcon,
 TrashIcon,
 TruckIcon
};
